var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "top margin-top-15 margin-bottom-20 flex" }, [
    _c("div", { staticClass: "top-left flex flex-align-center" }, [
      _c("img", {
        staticClass: "avatar margin-left-15 margin-right-25",
        attrs: { src: _vm.driverInfo.avatar },
      }),
      _c("div", [
        _c("div", { staticClass: "flex flex-align-center margin-bottom-20" }, [
          _c("span", { staticClass: "margin-right-10 font-18 font-weight" }, [
            _vm._v(_vm._s(_vm.driverInfo.name)),
          ]),
          _c(
            "div",
            { staticClass: "driver-pos pointer flex flex-align-center" },
            [
              _c(
                "span",
                {
                  staticClass: "font font-12 text-eli",
                  staticStyle: {
                    display: "inline-block",
                    "max-width": "300px",
                  },
                  on: { click: _vm.situationDetail },
                },
                [_vm._v("司机位置：" + _vm._s(_vm.driverInfo.location))]
              ),
              _c("i", {
                staticClass:
                  "el-icon-refresh-right margin-left-10 color-999 font-16",
                on: { click: _vm.refresh },
              }),
            ]
          ),
        ]),
        _c("div", { staticClass: "flex flex-align-center" }, [
          _c("div", { staticClass: "flex flex-col" }, [
            _c(
              "span",
              { staticClass: "title margin-bottom-5 font-12 color-999" },
              [_vm._v("手机号")]
            ),
            _c("span", { staticClass: "font-14 color-666" }, [
              _vm._v(_vm._s(_vm.driverInfo.mobilePhone)),
            ]),
          ]),
          _c("div", { staticClass: "line" }),
          _c("div", [
            _c("div", { staticClass: "flex flex-col" }, [
              _c(
                "span",
                { staticClass: "title margin-bottom-5 font-12 color-999" },
                [_vm._v("车牌号")]
              ),
              _c("span", { staticClass: "font-14 color-666" }, [
                _vm._v(_vm._s(_vm.driverInfo.plateNumber)),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "line" }),
          _c("div", [
            _c("div", { staticClass: "flex flex-col" }, [
              _c(
                "span",
                { staticClass: "title margin-bottom-5 font-12 color-999" },
                [_vm._v("所属供应商")]
              ),
              _c("span", { staticClass: "font-14 color-666" }, [
                _vm._v(_vm._s(_vm.driverInfo.merchantName)),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "top-right padding-15" }, [
      _c(
        "div",
        {
          staticClass:
            "title margin-bottom-15 flex flex-between flex-align-center",
        },
        [
          _c("span", { staticClass: "font-weight color-333" }, [
            _vm._v("今日数据"),
          ]),
          _c("span", { staticClass: "color-666 font-12" }, [
            _vm._v("数据更新时间 " + _vm._s(_vm.dataUpdateTime)),
          ]),
        ]
      ),
      _c("div", { staticClass: "content flex" }, [
        _c("div", { staticClass: "flex flex-col flex-align-center" }, [
          _c("span", { staticClass: "color-666 font-14 desc-title" }, [
            _vm._v("接单数"),
          ]),
          _c("div", [
            _c(
              "span",
              { staticClass: "font-24 color-333 font-weight margin-right-5" },
              [_vm._v(_vm._s(_vm.driverInfo.meetCount || 0))]
            ),
            _c("span", { staticClass: "color-999 font-12" }, [_vm._v("单")]),
          ]),
        ]),
        _c("div", { staticClass: "flex flex-col flex-align-center" }, [
          _c("span", { staticClass: "color-666 font-14 desc-title" }, [
            _vm._v("已完成订单数"),
          ]),
          _c("div", [
            _c(
              "span",
              { staticClass: "font-24 color-333 font-weight margin-right-5" },
              [_vm._v(_vm._s(_vm.driverInfo.finishCount || 0))]
            ),
            _c("span", { staticClass: "color-999 font-12" }, [_vm._v("单")]),
          ]),
        ]),
        _c("div", { staticClass: "flex flex-col flex-align-center" }, [
          _c("span", { staticClass: "color-666 font-14 desc-title" }, [
            _vm._v("在线时长"),
          ]),
          _c("div", [
            _c("span", { staticClass: "font-24 color-333 font-weight" }, [
              _vm._v(_vm._s(_vm.getHour(_vm.driverInfo.onlineTime))),
            ]),
            _c("span", { staticClass: "color-999 font-12 margin-x-5" }, [
              _vm._v("小时"),
            ]),
            _c(
              "span",
              { staticClass: "font-24 color-333 font-weight margin-right-5" },
              [_vm._v(_vm._s(_vm.getMin(_vm.driverInfo.onlineTime)))]
            ),
            _c("span", { staticClass: "color-999 font-12" }, [_vm._v("分")]),
          ]),
        ]),
        _c("div", { staticClass: "flex flex-col flex-align-center" }, [
          _c("span", { staticClass: "color-666 font-14 desc-title" }, [
            _vm._v("服务时长"),
          ]),
          _c("div", [
            _c("span", { staticClass: "font-24 color-333 font-weight" }, [
              _vm._v(_vm._s(_vm.getHour(_vm.driverInfo.serviceTime))),
            ]),
            _c("span", { staticClass: "color-999 font-12 margin-x-5" }, [
              _vm._v("小时"),
            ]),
            _c(
              "span",
              { staticClass: "font-24 color-333 font-weight margin-right-5" },
              [_vm._v(_vm._s(_vm.getMin(_vm.driverInfo.serviceTime)))]
            ),
            _c("span", { staticClass: "color-999 font-12" }, [_vm._v("分")]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }